import { Component } from '@angular/core';

@Component({
    selector: 'app-demo-layouts',
    templateUrl: './demo-layouts.component.html',
    styleUrls: ['./demo-layouts.component.scss', '../../styles/demo-styles.scss']
})
export class DemoLayoutsComponent {

    constructor() {
    }
}
